var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Switches',_vm._b({model:{value:(_vm.isEnabled),callback:function ($$v) {_vm.isEnabled=$$v},expression:"isEnabled"}},'Switches',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }